export const MODEL_CONFIGS_FETCH = 'model-configs.fetch-config';
export const MODEL_CONFIGS_CANCEL_FETCH = 'model-configs.cancel-fetch-config';
export const MODEL_CONFIGS_SET = 'model-configs.set-config';
export const MODEL_CONFIGS_SET_PRELOADED_CONFIGS = 'model-configs.set-preloaded-configs';
export const MODEL_CONFIGS_CLEAR = 'model-configs.clear';
export const MODEL_CONFIGS_SAVE_ERROR = 'model-configs.save-error';
export const MODEL_CONFIGS_RETRY_FETCH = 'model-configs.retry-fetch-config';
